<template>
    <div style="height:100%;display:flex;flex-direction:column">
        <div style="height:60px;background:rgba(34, 215, 187, 1)"></div>
        <div style="flex:1;overflow-y:auto;padding-bottom:40px;">
            <div style="text-align:right;margin-top:24px;margin-right:32px;">
                <a-button style="height:48px;line-height:48px;width:180px;text-align:center;color:rgba(139, 152, 167, 1);font-size:18px;border-radius:4px" icon="plus" @click="showModal">
                创建机器人
                </a-button>
            </div>
            <div style="padding:0 200px;">
                <div style="color:rgba(18, 18, 18, 1);font-size:16px;margin-bottom:24px">机器人列表</div>
                <a-table
                    :data-source="tableData"
                    :pagination='false'
                    :scroll="{ x: 'max-content' }"
                >
                    <a-table-column key="name" title="机器人名称" data-index="name" />
                    <a-table-column key="prologue" title="开场白" data-index="prologue">
                        <template slot-scope="text, record">
                            <span :title="record.prologue" style="max-width:600px;overflow:auto;display:inline-block">{{record.prologue}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="qaCount" title="QA数量" data-index="qaCount" />
                    <a-table-column key="createTime" title="创建时间" data-index="createTime" />
                    <a-table-column key="id" title="操作" data-index="id">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px;cursor:pointer;color:rgba(24, 144, 255, 1)" @click="startChat(record)">开始对话</span>
                            <span style="margin-right:8px;cursor:pointer;color:rgba(24, 144, 255, 1)" @click="editContent(record)">编辑</span>
                        </template>
                    </a-table-column>
                </a-table>
            </div>
        </div>
        <a-modal
            title="创建机器人"
            :visible="visible"
            @ok="handleOk"
            @cancel="handleCancel"
            >
            <div>
                <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin:0 0 8px 0">机器人名称：</div>
                <a-input v-model="robotName" placeholder="输入内容" />
                <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin:16px 0 8px 0">开场白：</div>
                <div>
                    <a-textarea
                        placeholder="输入内容"
                        v-model="robotContent"
                        :auto-size="{ minRows: 2, maxRows: 6 }"
                    />
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'Login',
    props: {
        msg: String
    },
    components: {  },
    data() {
        return {
            visible: false,
            tableData: [],
            robotName: '',
            robotContent: '',
            currentId: '',
        }
    },
    methods: {
        showModal() {
            this.visible = true;
            this.robotName = ''
            this.robotContent = ''
            this.currentId = ''
        },
        handleOk() {
            this.visible = false;
            this.axios.post('/api/bot', {
                id: this.currentId,
                name: this.robotName,
                prologue: this.robotContent,
            })
            .then(response=> {
                if(response.data.code == 0){
                    if(this.currentId == ''){
                        this.$message.success('新增成功') 
                    }else{
                        this.$message.success('修改成功') 
                    }
                    this.queryRobotData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        handleCancel() {
            this.visible = false;
            this.robotName = ''
            this.robotContent = ''
        },
        viewRecords(id) {
            console.log(id)
        },
        queryRobotData() {
            this.axios(
                {
                    method:'get',
                    url:'/api/bot/list', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.tableData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        startChat(record) {
            this.currentId = record.id
            this.$router.push({path: '/Chat',query:{ id: record.id,name: record.name,prologue: record.prologue,qaCount: record.qaCount,}})
        },
        editContent(record) {
            this.currentId = record.id
            this.visible = true;
            this.robotName = record.name
            this.robotContent = record.prologue
        }
    },
    mounted: function() {
        this.queryRobotData()
    }
}
</script>

<style scoped lang="less"> 
    
</style>
